/* tslint:disable */

/* eslint-disable */

/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import type { AxiosInstance, AxiosPromise, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";

// @ts-ignore
import {
  BASE_PATH,
  BaseAPI,
  COLLECTION_FORMATS,
  RequestArgs,
  RequiredError,
  operationServerMap,
} from "../base";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  createRequestFunction,
  serializeDataIfNeeded,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  toPathString,
} from "../common";
import type { Configuration } from "../configuration";
// @ts-ignore
import { AaClubsCacheData } from "../models";
// @ts-ignore
import { AaPlayersCacheData } from "../models";
// @ts-ignore
import { AccountIdMappingRequestDto } from "../models";
// @ts-ignore
import { ClubRegularDto } from "../models";
// @ts-ignore
import { ManagerClubRegularDto } from "../models";

/**
 * SysDataMainControllerApi - axios parameter creator
 * @export
 */
export const SysDataMainControllerApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {AccountIdMappingRequestDto} accountIdMappingRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAAAccountsExternalIds: async (
      accountIdMappingRequestDto: AccountIdMappingRequestDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'accountIdMappingRequestDto' is not null or undefined
      assertParamExists(
        "getAAAccountsExternalIds",
        "accountIdMappingRequestDto",
        accountIdMappingRequestDto
      );
      const localVarPath = `/api/v2/sys-data/aa_eco/accounts_externalids`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        accountIdMappingRequestDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {Set<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAAClubIdsMapping: async (
      requestBody: Set<string>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'requestBody' is not null or undefined
      assertParamExists("getAAClubIdsMapping", "requestBody", requestBody);
      const localVarPath = `/api/v2/sys-data/aa_eco/clubs_ids_mapping`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        requestBody,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} domain
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClubs: async (
      domain: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'domain' is not null or undefined
      assertParamExists("getClubs", "domain", domain);
      const localVarPath = `/api/v2/sys-data/{domain}/clubs`.replace(
        `{${"domain"}}`,
        encodeURIComponent(String(domain))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} domain
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getManagerClubs: async (
      domain: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'domain' is not null or undefined
      assertParamExists("getManagerClubs", "domain", domain);
      const localVarPath = `/api/v2/sys-data/{domain}/manager_clubs`.replace(
        `{${"domain"}}`,
        encodeURIComponent(String(domain))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} domain
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRoomWhitelist: async (
      domain: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'domain' is not null or undefined
      assertParamExists("getRoomWhitelist", "domain", domain);
      const localVarPath = `/api/v2/sys-data/{domain}/whitelist`.replace(
        `{${"domain"}}`,
        encodeURIComponent(String(domain))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} domain
     * @param {Set<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveRoomWhitelist: async (
      domain: string,
      requestBody: Set<string>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'domain' is not null or undefined
      assertParamExists("saveRoomWhitelist", "domain", domain);
      // verify required parameter 'requestBody' is not null or undefined
      assertParamExists("saveRoomWhitelist", "requestBody", requestBody);
      const localVarPath = `/api/v2/sys-data/{domain}/whitelist`.replace(
        `{${"domain"}}`,
        encodeURIComponent(String(domain))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        requestBody,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SysDataMainControllerApi - functional programming interface
 * @export
 */
export const SysDataMainControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SysDataMainControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {AccountIdMappingRequestDto} accountIdMappingRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAAAccountsExternalIds(
      accountIdMappingRequestDto: AccountIdMappingRequestDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<{ [key: string]: AaPlayersCacheData }>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAAAccountsExternalIds(
        accountIdMappingRequestDto,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["SysDataMainControllerApi.getAAAccountsExternalIds"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {Set<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAAClubIdsMapping(
      requestBody: Set<string>,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<{ [key: string]: AaClubsCacheData }>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAAClubIdsMapping(
        requestBody,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["SysDataMainControllerApi.getAAClubIdsMapping"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} domain
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getClubs(
      domain: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClubRegularDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getClubs(domain, options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["SysDataMainControllerApi.getClubs"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} domain
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getManagerClubs(
      domain: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ManagerClubRegularDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getManagerClubs(
        domain,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["SysDataMainControllerApi.getManagerClubs"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} domain
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRoomWhitelist(
      domain: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<string>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getRoomWhitelist(
        domain,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["SysDataMainControllerApi.getRoomWhitelist"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} domain
     * @param {Set<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async saveRoomWhitelist(
      domain: string,
      requestBody: Set<string>,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.saveRoomWhitelist(
        domain,
        requestBody,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["SysDataMainControllerApi.saveRoomWhitelist"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * SysDataMainControllerApi - factory interface
 * @export
 */
export const SysDataMainControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = SysDataMainControllerApiFp(configuration);
  return {
    /**
     *
     * @param {AccountIdMappingRequestDto} accountIdMappingRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAAAccountsExternalIds(
      accountIdMappingRequestDto: AccountIdMappingRequestDto,
      options?: any
    ): AxiosPromise<{ [key: string]: AaPlayersCacheData }> {
      return localVarFp
        .getAAAccountsExternalIds(accountIdMappingRequestDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {Set<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAAClubIdsMapping(
      requestBody: Set<string>,
      options?: any
    ): AxiosPromise<{ [key: string]: AaClubsCacheData }> {
      return localVarFp
        .getAAClubIdsMapping(requestBody, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} domain
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClubs(domain: string, options?: any): AxiosPromise<Array<ClubRegularDto>> {
      return localVarFp.getClubs(domain, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} domain
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getManagerClubs(
      domain: string,
      options?: any
    ): AxiosPromise<Array<ManagerClubRegularDto>> {
      return localVarFp
        .getManagerClubs(domain, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} domain
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRoomWhitelist(domain: string, options?: any): AxiosPromise<Set<string>> {
      return localVarFp
        .getRoomWhitelist(domain, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} domain
     * @param {Set<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveRoomWhitelist(
      domain: string,
      requestBody: Set<string>,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .saveRoomWhitelist(domain, requestBody, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * SysDataMainControllerApi - object-oriented interface
 * @export
 * @class SysDataMainControllerApi
 * @extends {BaseAPI}
 */
export class SysDataMainControllerApi extends BaseAPI {
  /**
   *
   * @param {AccountIdMappingRequestDto} accountIdMappingRequestDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SysDataMainControllerApi
   */
  public getAAAccountsExternalIds(
    accountIdMappingRequestDto: AccountIdMappingRequestDto,
    options?: RawAxiosRequestConfig
  ) {
    return SysDataMainControllerApiFp(this.configuration)
      .getAAAccountsExternalIds(accountIdMappingRequestDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {Set<string>} requestBody
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SysDataMainControllerApi
   */
  public getAAClubIdsMapping(requestBody: Set<string>, options?: RawAxiosRequestConfig) {
    return SysDataMainControllerApiFp(this.configuration)
      .getAAClubIdsMapping(requestBody, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} domain
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SysDataMainControllerApi
   */
  public getClubs(domain: string, options?: RawAxiosRequestConfig) {
    return SysDataMainControllerApiFp(this.configuration)
      .getClubs(domain, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} domain
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SysDataMainControllerApi
   */
  public getManagerClubs(domain: string, options?: RawAxiosRequestConfig) {
    return SysDataMainControllerApiFp(this.configuration)
      .getManagerClubs(domain, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} domain
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SysDataMainControllerApi
   */
  public getRoomWhitelist(domain: string, options?: RawAxiosRequestConfig) {
    return SysDataMainControllerApiFp(this.configuration)
      .getRoomWhitelist(domain, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} domain
   * @param {Set<string>} requestBody
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SysDataMainControllerApi
   */
  public saveRoomWhitelist(
    domain: string,
    requestBody: Set<string>,
    options?: RawAxiosRequestConfig
  ) {
    return SysDataMainControllerApiFp(this.configuration)
      .saveRoomWhitelist(domain, requestBody, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
